/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A6Inputs */

const en_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All payments are securely processed via Stripe. We never store your payment details on our servers.`)
};

const de_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Zahlungen werden sicher ueber Stripe abgewickelt. Wir speichern Ihre Zahlungsdaten niemals auf unseren Servern.`)
};

const fr_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const es_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const it_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const nl_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const pl_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const fi_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const da_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

const sv_pricing_faq_a6 = /** @type {(inputs: Pricing_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Student plan requires verification with a university email address (typically ending in .edu, .ac.uk, or a recognized university domain) to confirm your student status.`)
};

/**
* | output |
* | --- |
* | "All payments are securely processed via Stripe. We never store your payment details on our servers." |
*
* @param {Pricing_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a6 = /** @type {((inputs?: Pricing_Faq_A6Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A6Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a6(inputs)
	if (locale === "fr") return fr_pricing_faq_a6(inputs)
	if (locale === "es") return es_pricing_faq_a6(inputs)
	if (locale === "it") return it_pricing_faq_a6(inputs)
	if (locale === "nl") return nl_pricing_faq_a6(inputs)
	if (locale === "pl") return pl_pricing_faq_a6(inputs)
	if (locale === "fi") return fi_pricing_faq_a6(inputs)
	if (locale === "da") return da_pricing_faq_a6(inputs)
	if (locale === "sv") return sv_pricing_faq_a6(inputs)
	return en_pricing_faq_a6(inputs)
});